export function isEmpty() {
  return function (object) {
    return angular.equals({}, object);
  };
}
